<template>
  <div>
    <panel title="Paczki wniosków">
      <w-table
        entity-type="documentPack"
        :hide-search-input="true"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        :per-page="-1"
        @receive="confirmReceive"
        @goToMdok="goToMdok"
        @download="download"
      />
    </panel>

    <post-form class="d-none document-pack-download" :url="downloadUrl" />

    <receive-pack-modal
      :show="!!selectedPack"
      :pack-title="selectedPackName"
      @close="selectedPack = undefined"
      @receive="receive"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ReceivePackModal from '@/components/modals/ReceivePackModal';
import WTable from '@/components/table/Table';
import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm';
import { Errors } from '@/enums/errors.enum';
import { PackStatusTranslation } from '@/enums/packStatus.enum';
import { Successes } from '@/enums/successes.enum';
import { listMixin } from '@/mixins/list';
import { documentResource } from '@/resources/document.resource';
import { DOWNLOAD_ACTION, GO_TO_MDOK_ACTION, RECEIVE_ACTION } from '@/utils/constants';
import { tryParseInt } from '@/utils/number';
import { prepareDocumentPackQuery } from '@/utils/prepareDocumentPackQuery';
import { config } from '@/utils/config';
import { TableName } from '@/enums/tableName';

const messages = {
  listError: Errors.DOCUMENT_PACK_CANNOT_LIST,
  getError: Errors.DOCUMENT_PACK_CANNOT_GET
};

// @vuese
// Lista
// @group Packs
export default {
  components: { Panel, PostForm, ReceivePackModal, WTable },
  mixins: [listMixin('documentPack', messages)],
  data: () => ({
    columns: [
      { name: 'id', displayName: 'ID' },
      { name: 'structureNode.name', displayName: 'Nazwa szkoły', sortable: true },
      { name: 'name', displayName: 'Nazwa', sortable: true },
      { name: 'number', displayName: 'Numer', sortable: true },
      { name: 'status', displayName: 'Status', sortable: true, nameTransformer: value => PackStatusTranslation[value] }
    ],
    selectedPack: undefined,
    downloadUrl: ''
  }),

  computed: {
    ...mapState({
      isSecretary: state => !!state.auth.nodes?.length,
      attachments: state => state.procedure.attachment.list
    }),

    selectedPackName() {
      return this.selectedPack?.name;
    },

    actions() {
      return [RECEIVE_ACTION, GO_TO_MDOK_ACTION(this.isSecretary), DOWNLOAD_ACTION];
    }
  },

  methods: {
    // @vuese
    // Odbiera paczkę dokumentów po potwierdzeniu
    confirmReceive(data) {
      this.selectedPack = data;
    },

    // @vuese
    // Odbiera paczkę dokumentów
    receive(packMdokId) {
      const data = { id: this.selectedPack.id, packMdokId };
      this.$store
        .dispatch('documentPack/receive', data)
        .then(() => {
          this.notifySuccess(Successes.DOCUMENT_PACK_RECEIVED);
          this.selectedPack = undefined;
          this.updateList(this.$route);
        })
        .catch(err => this.notifyError(Errors.DOCUMENT_PACK_CANNOT_RECEIVE));
    },

    // @vuese
    // Zwraca UID MDOK paczki
    mdokUid(pack) {
      if (this.isSecretary) {
        return pack.systemNumbers?.mdokJoId;
      }
      return pack.systemNumbers?.mdokId;
    },

    // @vuese
    // Przejście do MDOK
    goToMdok(pack) {
      documentResource
        .getMdokUrlByUid(parseInt(this.mdokUid(pack)), undefined, pack.id)
        .then(url => window.open(url, '_blank'))
        .catch(err => this.notifyError(Errors.MDOK_LINK_FAILED));
    },

    // @vuese
    // Filtry listy
    getFilters(route) {
      return prepareDocumentPackQuery(route);
    },

    // @vuese
    // Pobranie pliku z paczką wnioksów
    download(documentPack) {
      const attachment = this.attachments.find(
        procedureAttachment => procedureAttachment.metadata?.documentPackId === documentPack.id
      );
      if (!attachment) {
        this.notifyError('Nie znaleziono pliku dla wybranej paczki wniosków.');
        return;
      }
      this.downloadUrl = config.mediaURL + '/' + attachment.mediaId;
      this.$nextTick(() => document.querySelectorAll('.document-pack-download .post-form')[0].click());
    }
  }
};
</script>
